import React from 'react'

const CalendarIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 36 32.8" {...props}>
    <g transform="translate(0 2.4)">
      <path
        d="M-42.6,247H-75.4a1.6,1.6,0,0,1-1.6-1.6V218.2a1.6,1.6,0,0,1,1.6-1.6h4.8v1.6h-4.8v27.2h32.8V218.2h-4.8v-1.6h4.8a1.6,1.6,0,0,1,1.6,1.6v27.2A1.6,1.6,0,0,1-42.6,247Z"
        transform="translate(77 -216.6)"
        fill="#abacb9"
      />
    </g>
    <g transform="translate(0.8 8.8)">
      <rect width="34.4" height="1.6" fill="#abacb9" />
    </g>
    <g transform="translate(27.2)">
      <rect width="1.6" height="5.6" fill="#abacb9" />
    </g>
    <g transform="translate(9.6 2.4)">
      <rect width="16.8" height="1.6" fill="#abacb9" />
    </g>
    <g transform="translate(7.2)">
      <rect width="1.6" height="5.6" fill="#abacb9" />
    </g>
    <g transform="translate(12.8 15.2)">
      <rect width="2.4" height="1.6" fill="#abacb9" />
    </g>
    <g transform="translate(16.8 15.2)">
      <rect width="2.4" height="1.6" fill="#abacb9" />
    </g>
    <g transform="translate(20.8 15.2)">
      <rect width="2.4" height="1.6" fill="#abacb9" />
    </g>
    <g transform="translate(24.8 15.2)">
      <rect width="2.4" height="1.6" fill="#abacb9" />
    </g>
    <g transform="translate(8.8 19.2)">
      <rect width="2.4" height="1.6" fill="#abacb9" />
    </g>
    <g transform="translate(12.8 19.2)">
      <rect width="2.4" height="1.6" fill="#abacb9" />
    </g>
    <g transform="translate(16.8 19.2)">
      <rect width="2.4" height="1.6" fill="#abacb9" />
    </g>
    <g transform="translate(20.8 19.2)">
      <rect width="2.4" height="1.6" fill="#abacb9" />
    </g>
    <g transform="translate(24.8 19.2)">
      <rect width="2.4" height="1.6" fill="#abacb9" />
    </g>
    <g transform="translate(8.8 23.2)">
      <rect width="2.4" height="1.6" fill="#abacb9" />
    </g>
    <g transform="translate(12.8 23.2)">
      <rect width="2.4" height="1.6" fill="#abacb9" />
    </g>
    <g transform="translate(16.8 23.2)">
      <rect width="2.4" height="1.6" fill="#abacb9" />
    </g>
    <g transform="translate(20.8 23.2)">
      <rect width="2.4" height="1.6" fill="#abacb9" />
    </g>
  </svg>
)

export { CalendarIcon }
